/**
 * 新手指引
 */
export default [
  {
    path: '/guide/index',
    component: () => import('@/views/admin/guide'),
    meta: { title: '新手指引' },
    redirect: '/guide/one',
    children: [
      {
        path: '/guide/one',
        component: () => import('@/views/admin/guide/one'),
        meta: { title: '新手指引' }
      },
      {
        path: '/guide/two',
        component: () => import('@/views/admin/guide/two'),
        meta: { title: '新手指引' }
      },
      {
        path: '/guide/three',
        component: () => import('@/views/admin/guide/three'),
        meta: { title: '新手指引' }
      },
      {
        path: '/guide/four',
        component: () => import('@/views/admin/guide/four'),
        meta: { title: '新手指引' }
      }
    ]
  }
]
